/// <amd-module name="Test/TestResultsSettings/Components/FadeToast" />
import * as React from "react";
import { Toast } from "VSSUI/Toast";

interface IFadeToastProps {
    content: string;
}

export class FadeToast extends React.Component<IFadeToastProps> {
    private _toastRef: React.RefObject<Toast> = React.createRef<Toast>();

    public render() {
        return <Toast ref={this._toastRef} message={this.props.content}></Toast>;
    }

    public componentDidMount() {
        setTimeout(() => {
            if (this._toastRef && this._toastRef.current) {
                this._toastRef.current.fadeOut();
            }
        }, 4000);
    }
}
